import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/portfolio/Navbar";
import Hero from "@/components/portfolio/Hero";
import About from "@/components/portfolio/About";
import Certificates from "@/components/portfolio/Certificates";
import Services from "@/components/portfolio/Services";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import FloatingWhatsApp from "@/components/portfolio/FloatingWhatsApp";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from '@/components/clinic/AuthContext';
import { ClinicLayout } from '@/components/clinic/ClinicLayout';
import LoginPage from '@/pages/clinic/LoginPage';
import ClientsPage from '@/pages/clinic/ClientsPage';
import WorkspacePage from '@/pages/clinic/WorkspacePage';
import DietsPage from '@/pages/clinic/DietsPage';
import SettingsPage from '@/pages/clinic/SettingsPage';
import { useEffect } from 'react';
import Lenis from 'lenis';
import '@/clinic.css';

function Portfolio() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const lenis = new Lenis({ autoRaf: true, duration: 1.1, anchors: true });
    return () => lenis.destroy();
  }, []);
  return (
    <div className="App min-h-screen bg-[#F5F5F0] text-[#0A1628]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Certificates />
        <Services />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A1628",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return <BrowserRouter><Routes>
    <Route path="/" element={<Portfolio />} />
    <Route path="/*" element={<AuthProvider><Routes>
      <Route path="/giris" element={<LoginPage />} />
      <Route path="/login" element={<Navigate to="/giris" replace />} />
      <Route element={<ProtectedRoute />}><Route path="/panel" element={<ClinicLayout />}>
        <Route index element={<ClientsPage />} />
        <Route path="danisanlar/yeni" element={<WorkspacePage />} />
        <Route path="danisanlar/:id" element={<WorkspacePage />} />
        <Route path="planlar" element={<DietsPage />} />
        <Route path="ayarlar" element={<SettingsPage />} />
      </Route></Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes><Toaster position="top-right" richColors /></AuthProvider>} />
  </Routes></BrowserRouter>;
}

export default App;
